
export default {
  props: ["prev", "next"],
};
